// All callers provide a live-operation guard so late replies cannot affect a new workspace.
export function assertCurrent(isCurrent) {
 if(isCurrent && !isCurrent())throw new DOMException('Opération terminée.', 'AbortError');
}
export async function accountRequest(action,{data,csrfToken,signal,isCurrent,onSessionInvalid}={}){
 assertCurrent(isCurrent);
 const response=await fetch('/api/account.php?action='+action,{method:data===undefined?'GET':'POST',credentials:'same-origin',cache:'no-store',signal,headers:data===undefined?{}:{'Content-Type':'application/json','X-CSRF-Token':csrfToken||''},...(data===undefined?{}:{body:JSON.stringify(data)})});
 assertCurrent(isCurrent);
 if(response.status===401||response.status===403){onSessionInvalid?.('Votre session a expiré ou ne correspond plus à cet espace. Reconnectez-vous.');throw Error('Session non valide.');}
 let body;try{body=await response.json();}catch{assertCurrent(isCurrent);throw Error('Service de comptes indisponible. Réessayez lorsque la connexion est rétablie.');}
 assertCurrent(isCurrent);
 if(!response.ok)throw Error(body.error||`Requête refusée (${response.status}).`);
 return body;
}
export function assertSessionOwner(session,ownerId,onSessionInvalid){
 if(typeof ownerId!=='string'||!ownerId||session?.authenticated!==true||session?.user?.id!==ownerId||typeof session.csrfToken!=='string'||!session.csrfToken){
  onSessionInvalid?.('La session a changé. Reconnectez-vous pour ouvrir votre espace privé.');
  throw Error('La session ne correspond plus à cet espace.');
 }
 return session;
}
export async function verifyAccountSession(ownerId,options={}){
 const session=await accountRequest('status',options);
 assertCurrent(options.isCurrent);
 return assertSessionOwner(session,ownerId,options.onSessionInvalid);
}
